import { type Parser } from "../../base_classes/dto_parser.d";

const parsers: Parser[] = [];

export default parsers;
